import axios from "axios";
import * as XLSX from "xlsx";

export function downloadTrainingReport(selectedTraining) {
  axios.defaults.headers["Authorization"] = localStorage.getItem("token");

  axios
    .get(
      localStorage.getItem("BASE_PATH") + "/trainings/get/" + selectedTraining
    )
    .then((response) => {
      if (response.data.unAuth) {
        this.$toasted.global.errorMsg(
          "Your are Unauthorized. Need to Login Again"
        );
        localStorage.clear();
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      }
      if (response.data.tokenExpired) {
        this.$toasted.global.errorMsg(response.data.tokenExpired);
        localStorage.clear();
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      }

      const report = response.data;
      const participantsData = report.listTrainees.map((trainee) => {
        return [
          report.training.district?.province?.country?.title ?? "", // Country
          report.training.startdate ?? "", // start date
          report.training.enddate ?? "", // end date
          report.training.title ?? "", // Training title
          report.training.trainingTopic ?? "", // Event Topic
          report.training.trainingtype?.title ?? "", // Event Type
          combineTrainerNames(report.trainers), // Event Delivered By:
          report.training.venue ?? "", // Event Location
          trainee.name ?? "", // Participant Name
          trainee.contactNo ?? "", // Contact No
          trainee.cnic ?? "", // CNIC
          trainee.email ?? "", // Email
          trainee.department?.[0]?.title ?? "", // Department/Section
          trainee.sector?.[0]?.name ?? "", // Sector
          report.training.district?.province?.title ?? "", // Province of Origin
          trainee.gender ?? "", // Gender
          trainee.designation?.[0]?.title ?? "", //Designation
          preTestScore(trainee), //Pre-Test Score
          postTestScore(trainee), // Post-Test Score
          exhibitedBehavior(trainee), // Exhibited Behavior Change?
        ];
      });
      const data = [
        [
          "Country",
          "Start Date",
          "End Date",
          "Training/Event Title",
          "Training/Event Topic",
          "Training/Event Type",
          "Training/Event Delivered By:",
          "Training/Event Location",
          "Participant Name",
          "Contact No",
          "CNIC",
          "Email",
          "Department/Section",
          "Sector",
          "Participant Region/Province of Origin",
          "Gender",
          "Designation",
          "Pre-Test Score",
          "Post-Test Score",
          "Exhibited Behavior Change?",
        ],
        ...participantsData,
      ];

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Add a worksheet with the data
      const ws = XLSX.utils.aoa_to_sheet(data);
      // Apply filter to the worksheet
      ws["!autofilter"] = {
        ref: "A1:S1",
      }; // Assuming headers are in A1:F1
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      // Generate a blob from the workbook
      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });
      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      // Set the download URL and click the anchor to trigger the download
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Training Report.xlsx";
      a.click();
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
}

function combineTrainerNames(trainersArray) {
  const trainerNames = trainersArray.map((trainer) => trainer.trainer.name);
  const combinedNames = trainerNames.join(",");
  return combinedNames;
}
function combineTrainerId(trainersArray) {
  const trainerNames = trainersArray.map((trainer) => trainer.trainer.id);
  const combinedNames = trainerNames.join(",");
  return combinedNames;
}
function preTestScore(trainees) {
  if (trainees?.FalsePreQuestion !== null) {
    return (
      ((trainees.TruePreQuestion / trainees.totalAssessment) * 100).toFixed(2) +
      "%"
    );
  } else {
    return "Not Solved";
  }
}
function postTestScore(trainees) {
  if (trainees.FalsePostQuestion != null) {
    return (
      ((trainees.TruePostQuestion / trainees.totalAssessment) * 100).toFixed(
        2
      ) + "%"
    );
  } else {
    return "Not Solved";
  }
}
function exhibitedBehavior(trainees) {
  if (trainees.TruePostQuestion > trainees.TruePreQuestion) {
    return "YES";
  } else {
    return "NO";
  }
}
